module.exports = __webpack_public_path__ + "7.jpg?e820bbe9e825fed816d3613214bac131";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resources/img/7.jpg
// module id = 62
// module chunks = 0